import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { SafeArea, SafeAreaInsets } from 'capacitor-plugin-safe-area';

// A partir do Android 15 (API 35), com targetSdk >= 35, o app é desenhado atrás das barras do sistema (edge-to-edge)
const ANDROID_EDGE_TO_EDGE_SDK = 35;

@Injectable({
    providedIn: 'root',
})
export class SafeAreaService {
    /**
     * No Android edge-to-edge o WebView nem sempre informa o env(safe-area-inset-*),
     * e aparelhos com botões de navegação acabam com os tabs por baixo da barra.
     * Aqui lemos as medidas reais do aparelho e sobrescrevemos as variáveis de safe area do Ionic.
     */
    async init() {
        // No iOS o env(safe-area-inset-*) já funciona
        if (Capacitor.getPlatform() !== 'android') return;

        // Abaixo do Android 15 o WebView não fica atrás das barras, então não há nada a compensar
        const { androidSDKVersion } = await Device.getInfo();
        if (!androidSDKVersion || androidSDKVersion < ANDROID_EDGE_TO_EDGE_SDK) return;

        const { insets } = await SafeArea.getSafeAreaInsets();
        this.applyInsets(insets);

        // Disparado quando o aparelho gira
        await SafeArea.addListener('safeAreaChanged', ({ insets }) => this.applyInsets(insets));
    }

    private applyInsets(insets: SafeAreaInsets['insets']) {
        const root = document.documentElement;
        for (const [side, value] of Object.entries(insets)) {
            root.style.setProperty(`--ion-safe-area-${side}`, `${value}px`);
        }
    }
}
